"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dys = exports.dxs = void 0;
const dxs = [+1, 0, -1, 0, +1, +1, -1, -1];
exports.dxs = dxs;
const dys = [0, +1, 0, -1, +1, -1, +1, -1];
exports.dys = dys;